import { Component } from "react";
import { Button } from "./ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 lg:p-8 max-w-2xl space-y-4" data-testid="error-boundary-fallback">
          <h2 className="font-display text-xl font-semibold text-zinc-100">Algo deu errado nesta tela</h2>
          <p className="text-sm text-zinc-400">
            Um erro inesperado ocorreu, mas seus dados estão seguros. Recarregue a página para continuar.
          </p>
          <Button onClick={() => window.location.reload()} data-testid="error-boundary-reload"
            className="brand-gradient brand-gradient-hover text-white border-0">
            Recarregar página
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
